
  import Radar from '~/node_modules/radar-sdk-js'
  import 'radar-sdk-js/dist/radar.css'
  import maplibregl from 'maplibre-gl'
  import moment from 'moment'

  import { mapState, mapActions, mapMutations } from 'vuex'

  export default {
    data() {
      return {
        map: false,
        activeLocation: null,
        markersAdded: false,
        markers: [],
      }
    },
    mounted() {
      const radarKey = process.env.RADAR_KEY
      if (!radarKey) {
        this.$utils.log('RadarMap - RADAR_KEY is missing')
        return
      }

      setTimeout(() => {
        this.initialize()

        if (this.appRadar['add_markers_on_initialize']) {
          // add all markers by default
          this.addMarkers(this.locations)
        } else if (this.location) {
          this.addMarker()
        }

        this.$nextTick(() => {
          document.addEventListener('click', function(e) {
            if (e.target.hasAttribute('data-order')) {
              this.startOrder(this.activeLocation)
            }
            else if (e.target.hasAttribute('data-reservation')) {
              this.goToReserveTable()
            }
            else if (e.target.innerText === 'ANNEX') {
              this.goToAnnexOrder()
            }
          }.bind(this))
          const logo = document.querySelector('#radar-map-logo')
          if (logo) {
            logo.setAttribute('aria-label', 'Radar map')
          }
          const logoImg = document.querySelector('#radar-map-logo > img')
          if (logoImg) {
            logoImg.setAttribute('alt', 'Logo')
          }

        })
      }, 200)
    },
    computed: {
      ...mapState([ 'appInfo', 'cart', 'location', 'geolocation', 'channel' ]),
      ...mapState({
        all: state => state.locations.all,
        results: state => state.locations.results,
        handoffMode: state => state.order.handoffMode,
      }),
      locations() {
        if (this.results && this.results.length) {
          return this.results
        } else {
          return this.all.reduce((acc, state) => {
            state.cities.forEach((city) => {
              city.locations.forEach((location) => acc.push(location))
            })

            return acc
          }, [])
        }
      },
      popup() {
        if (document.querySelector('.radar-map-popup')) {
          return document.querySelector('.radar-map-popup').innerHTML
        }
      },
      appRadar() {
        return this.appInfo['radar_map']
      },
      orderHere() {
        return 'Order Here'
        // TODO: the handoffMode may not be in sync with the store here
      },
      locationDisabled() {
        switch(this.handoffMode) {
          case 'pickup':
          case 'delivery':
          case 'curbside':
          case 'drivethru':
          case 'ordering':
            return !this.activeLocation.services[this.handoffMode]
          default:
            return false
        }
      },
      hasReservation() {
        return this.appRadar?.enable_reservation
      },
      isMobile() {
        return this.$mq === 'sm' || this.$mq === 'md'
      },
      viewDetails() {
        if (this.appRadar?.view_details_cta_text) {
          return this.appRadar.view_details_cta_text
        }

        return 'View Details'
      },
    },
    methods: {
      ...mapActions([ 'trackEvent', 'sendRequest', 'changeLocation', 'createCart', 'transferCart', 'abandonCart' ]),
      ...mapActions({
        createCateringCart: 'catering/createCart',
        transferCateringCart: 'catering/transferCart'
      }),
      ...mapMutations({
        setHandoffMode: 'order/setHandoffMode',
      }),
      ...mapMutations([ 'setLocation', 'setErrors', 'setLoading', 'setMenu' ]),
      initialize() {
        const radarKey = process.env.RADAR_KEY

        Radar.initialize(radarKey)
        // prevent duplicate maps from rendering over each other
        if (this.map) {
          this.map.remove()
          this.map = false
        }
        this.map = Radar.ui.map({ container: 'map' })
        this.map.setStyle(this.appRadar.style)
        this.map.on('error', (err) => {
          console.error(err)
        })
      },
      zoomInLocation() {
        if (this.map && typeof this.map.setZoom === 'function') {
          this.map.setZoom(this.appRadar['single_result_zoom'] || this.appRadar['results_zoom'])
          setTimeout(() => this.map.setCenter([this.location.lng, this.location.lat]), 250)
        }
      },
      addMarker() {
        const marker = document.createElement('div')
        marker.className = 'marker'
        marker.style.backgroundImage = 'url('+this.appRadar.marker.url+')'
        marker.style.width = this.appRadar.marker.width
        marker.style.height = this.appRadar.marker.height
        marker.style.backgroundSize = this.appRadar.marker['background_size']
        marker.style.backgroundRepeat = this.appRadar.marker['background_repeat']
        marker.addEventListener('click', () => {
          this.setActiveLocation(this.location)
        })
        this.markers.push(marker)
        
        new maplibregl.Marker(marker)
          .setLngLat([this.location.lng, this.location.lat])
          .addTo(this.map)
        this.zoomInLocation()
      },
      addMarkers(locationsList = [], checkNoResults = false) {
        if (!this.map || locationsList.length === 0) return;

        locationsList.forEach((location, i) => {
          if (!location || !location.lng || !location.lat) return;

          const marker = document.createElement('div')
          marker.className = 'marker'
          marker.style.backgroundImage = 'url('+this.appRadar.marker.url+')'
          marker.style.width = this.appRadar.marker.width
          marker.style.height = this.appRadar.marker.height
          marker.style.backgroundSize = this.appRadar.marker['background_size']
          marker.style.backgroundRepeat = this.appRadar.marker['background_repeat']
          marker.addEventListener('click', () => {
            this.setActiveLocation(location)
          })
          this.markers.push(marker)

          if (!location.key) { // all locations
            const popup = new maplibregl.Popup({ offset: this.appRadar.offset })
              .setLngLat([location.lng, location.lat])
              .setHTML(this.popup)
              .addTo(this.map)
            new maplibregl.Marker(marker)
              .setLngLat([location.lng, location.lat])
              .setPopup(popup)
              .addTo(this.map)
          } else { // search results
            new maplibregl.Marker(marker)
              .setLngLat([location.lng, location.lat])
              .addTo(this.map)
          }

          // center the map to the first result on search
          if (i == 0 && !this.location) {
            if (locationsList?.length === 1) {
              this.map.setZoom(this.appRadar['single_result_zoom'] || this.appRadar['results_zoom'])
            } else {
              this.map.setZoom(this.appRadar['multiple_results_zoom'] || this.appRadar['results_zoom'])
            }
            if(typeof this.map.setCenter === 'function') {
              setTimeout(() => this.map.setCenter([location.lng, location.lat]), 250)
            }
          }
        })

        // No locations found
        if (checkNoResults && locationsList.length === 0) {
          if (this.isMobile && this.appRadar['initial_zoom_mobile']) {
            this.map.setZoom(this.appRadar['initial_zoom_mobile'])
          } else if (this.appRadar['initial_zoom']) {
            this.map.setZoom(this.appRadar['initial_zoom'])
          }
          
          setTimeout(() => {
            this.map.setCenter([
              this.appRadar['initial_center'].lng,
              this.appRadar['initial_center'].lat,
            ])
          }, 250)
        }
      },
      async setActiveLocation(location) {
        if (location.key) { // get full location information if user hasn't searched
          location = await this.$api.getLocation(location.key, false, false, false)
        } else {
          // Get live location data to replace cached data
          this.setLoading(true)
          const locConfig = {
            method: 'get',
            url: `locations/${location.menu_id}`,
            params: {
              byMenuId: true
            }
          }
          let response = await this.sendRequest(locConfig)
          if (response.status === 'ok') {
            location = response.data
          }
          this.setLoading(false)
        }
        this.activeLocation = location
        setTimeout(() => {
          new maplibregl.Popup({ offset: this.appRadar.offset })
            .setLngLat([location.lng, location.lat])
            .setHTML(document.querySelector('.radar-map-popup').innerHTML)
            .addTo(this.map)
          this.map.flyTo({
            center: [location.lng, location.lat],
            zoom: this.appRadar['single_result_zoom'] || this.appRadar['results_zoom'],
            essential: true,
            duration: 1500
          })
        }, 100)
      },
      async startOrder(loc) {
        if (!loc) return
        if (!loc.services[this.handoffMode] && this.handoffMode !== 'reservation') {
          this.setErrors(`${loc.name} doesn't offer ${this.handoffMode}.`)
          return
        }

        this.changeLocation(loc)
        if (!this.location) {
          this.setLocation(loc)
        }
        this.trackEvent({
          name: 'select_location',
          data: loc,
          windowObject: window
        })
        this.setMenu(null)
        
        if (this.cart && this.location && this.channel === 'catering') {
          if (this.cart && this.cart.type === 'catering' && this.cart.menu_id !== this.location.menu_id) {
            await this.transferCateringCart(this.location.menu_id)
          } else if (this.cart && this.cart.type !== 'catering') {
            await this.abandonCart()
          } else {
            await this.createCateringCart()
          }
        } else if (this.cart && this.location) {
          if (this.cart && this.cart.type === 'mealtime' && this.cart.menu_id !== this.location.menu_id) {
            await this.transferCart(this.location.menu_id)
          } else if (this.cart && this.cart.type !== 'mealtime') {
            await this.abandonCart()
          } else {
            await this.createCart()
          }
        } else if (!this.cart) {
          if (this.channel === 'catering') {
            this.createCateringCart()
          } else {
            this.createCart()
          }
        }
      },
      isOpen(loc) {
        const dayOfWeek = parseInt(moment().format('e'))
        const hours = loc.hours[dayOfWeek]

        if (hours !== undefined) {
          const now = this.nowTimeAtLocation(loc)
          const open = moment(hours.open, 'HH:mm')
          let close = moment(hours.close, 'HH:mm')

          // if close time is after midnight of the next day, add a day to close
          if (close < open) {
            close = close.add(1, 'day')
          }

          return now > open && now < close
        } else {
          return false
        }
      },
      nowTimeAtLocation(loc) {
        const localUtcOffset = moment().utcOffset() / 60
        const locationUtcOffset = loc.utcoffset || loc.utcOffset
        const absoluteLocalUtcOffset = Math.abs(localUtcOffset)
        const absoluteLocationUtcOffset = Math.abs(locationUtcOffset)
        const difference = Math.abs(localUtcOffset - locationUtcOffset)

        let now = moment()
        if (absoluteLocalUtcOffset < absoluteLocationUtcOffset) {
          // local time is ahead
          now = moment().subtract(difference, 'hours')
        } else if (absoluteLocalUtcOffset > absoluteLocationUtcOffset) {
          // local time is behind
          now = moment().add(difference, 'hours')
        }

        return now
      },
      goToReserveTable() {
        this.setHandoffMode('reservation')
        this.setLocation(this.activeLocation)
        this.setMenu(null)
        this.trackEvent({
          name: 'select_location',
          data: this.activeLocation,
          windowObject: window
        })
      },
      goToAnnexOrder() {
        this.setHandoffMode('annex')
        this.setLocation(this.activeLocation)
        this.setMenu(null)
      },
      getCustomMenuUrl(loc) {
        if (!loc.attributes) return

        const urlFound = loc.attributes.find(a => a.id === 'url_menu' && a.value)
        if (!urlFound) return

        return urlFound.value
      },
      removeMarkers() {
        this.markers.forEach((marker) => marker.remove())
        this.markers = []
      },
    },
    watch: {
      results() {
        // this.initialize()
        if (this.markersAdded) {
          // remove all markers
          this.removeMarkers()

          const checkNoResults = true
          this.addMarkers(this.results, checkNoResults)
        }
        this.markersAdded = true
      },
      location() {
        if (this.location) {
          this.zoomInLocation()
        }
      },
      geolocation() {
        if(!this.map || !this.geolocation || this.location) return
        
        this.map.setCenter([
          this.geolocation.lng,
          this.geolocation.lat
        ])
      }
    },
    beforeDestroy () {
      if (this.map) {
        this.map?.remove()
        this.map = false
      }
    },
  }
